/** @format */

import template from './gb-edit-table-items-dialog.html';
import { GbEditTableItemsDialogController as controller } from './gb-edit-table-items-dialog.controller';

export class GbEditTableItemsDialogService {
    constructor($mdDialog) {
        'ngInject';

        this.$mdDialog = $mdDialog;
    }

    show(data = {}) {
        return this.$mdDialog.show({
            template,
            locals: {
                items: data.items,
                widget: data.widget,
            },
            controller,
            controllerAs: 'EditTableItems',
            theme: 'default',
        });
    }
}
